import { getAuthHeaders } from './apiUtils';
import { ServerURI } from '../globals';

export async function acceptTerms(version) {
  const response = await fetch(`${ServerURI}/api/v3/users/me/terms`, {
    method: 'POST', headers: { ...await getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ version }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Could not record terms acceptance.');
  return data;
}
